import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { enforceStrictBackendMatch } from "./guards/backendMatchGuard";

// S0_STRICT_BACKEND_MATCH — runs BEFORE React mount.
// Same-origin "/api" always passes. Blocks only on cross-origin mismatch.
const guardResult = enforceStrictBackendMatch(true);
if (!guardResult.ok) {
  // Block screen already rendered by the guard. Stop here.
} else {

// Suppress React hydration warnings caused by Emergent platform's
// data-ve-dynamic span injection. These are NOT app bugs — the platform
// injects <span> elements into the DOM after React renders, which React
// detects as mismatches. This only happens in the preview environment.
const originalError = console.error;
console.error = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (msg.includes('cannot be a child of') || msg.includes('hydration error')) return;
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

}
